import { Component, OnInit } from '@angular/core';
import { DTOUserEmail } from '../../../@core/models/dto-user-email';

@Component({
  selector: 'ngx-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {

  public email: string;
  public tokenSent: boolean = false;
  public submitted: boolean = false;
  constructor() {}

  ngOnInit() {
  }

  public requestPass() {
    const dtoEmail = new DTOUserEmail();
    dtoEmail.Email = this.email;
    /*this.userService.sendPasswordResetTokenFromEmail(dtoEmail).subscribe(result => {
      if (result === true) {
        this.tokenSent = true;
      } else {
        alert('Failed to send token');
      }
    });*/
  }
}
